import "./assets/css/all.min.css";
import "./assets/css/animate.css";
import "./assets/css/aos.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/solid.min.css";
import "./assets/main.css";
import "./assets/style.css";

import { HashRouter } from "react-router-dom";
import apiRequest from "./utils/apiRequest";
import PsContextProvider from "./context/PsContextProvider";
import RouteUrls from "./routes";
import { useEffect } from "react";
import { THEME_VARIANT } from "./utils";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const themeVariantColor = [
  { primary: "#1976d2" },
  { error: "#d32f2f" },
  { warning: "#ed6c02" },
  { success: "#2e7d32" },
  { purple: "#9c27b0" },
  { pink: "#ff3f81" },
];

const colorObjValue = themeVariantColor.find(
  (colorObj) => colorObj[THEME_VARIANT]
);

const customTheme = createTheme({
  palette: {
    primary: {
      main: colorObjValue[THEME_VARIANT], // Primary color (green)
    },
  },
});

const App = () => {
  useEffect(() => {
    try {
      document.body.classList.add(`ps_app_cls_${THEME_VARIANT}`);
    } catch (er) {
      console.log(er);
    }
  }, []);

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <div id="kalvisalai_app_layout">
          <div id="kalvisalai_app_content">
            <PsContextProvider>
              <HashRouter>
                <RouteUrls />
              </HashRouter>
            </PsContextProvider>
          </div>
        </div>
      </ThemeProvider>
      <iframe
        name="print_frame"
        id="print_frame"
        width="0"
        height="0"
        frameBorder="0"
        src="about:blank"
      ></iframe>
    </>
  );
};

export default App;
